import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Failed Order.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListFailedOrderPage - Lazy-loaded ListFailedOrderPage component.
 */
const FailedOrderListPage = Loadable(
  lazy(() => import("./ListFailedOrderPage"))
);

/**
 * Array containing route definitions for the Payout-related pages.
 * @constant {Object[]} PayoutPageRoutes - Array of Payout route objects.
 * @property {React.ReactElement} PayoutPageRoutes[].element - The React element to be rendered for the Payout route.
 */
const FailedOrderPageRoutes = [
  {
    path: "list",
    element: <FailedOrderListPage />,
  },
];

export default FailedOrderPageRoutes;
